/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Group_GuidesInputs */

const en_sidebar_group_guides = /** @type {(inputs: Sidebar_Group_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides`)
};

const ko_sidebar_group_guides = /** @type {(inputs: Sidebar_Group_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가이드`)
};

const ja_sidebar_group_guides = /** @type {(inputs: Sidebar_Group_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイド`)
};

/**
* | output |
* | --- |
* | "Guides" |
*
* @param {Sidebar_Group_GuidesInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_group_guides = /** @type {((inputs?: Sidebar_Group_GuidesInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Group_GuidesInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_group_guides(inputs)
	if (locale === "ko") return ko_sidebar_group_guides(inputs)
	return ja_sidebar_group_guides(inputs)
});